export type AcademiaPricingCategory = {
  id: 'JEUNESSE_PRIORITAIRE' | 'ADULTE_STANDARD' | 'FONCTIONNAIRE_EMPLOYE';
  label: string;
  inscription: string;
  participation: string;
  brevet: string;
};

/** Tarifs vitrine par catégorie d'âge / profil. */
export const ACADEMIA_PRICING_BY_CATEGORY: AcademiaPricingCategory[] = [
  {
    id: 'JEUNESSE_PRIORITAIRE',
    label: 'Jeunesse prioritaire (17–29 ans)',
    inscription: '10 000 CDF',
    participation: '240 000 CDF',
    brevet: '50 USD',
  },
  {
    id: 'ADULTE_STANDARD',
    label: 'Adulte standard (30 ans et +)',
    inscription: '10 000 CDF',
    participation: '340 000 CDF',
    brevet: '50 USD',
  },
  {
    id: 'FONCTIONNAIRE_EMPLOYE',
    label: 'Fonctionnaire / employé',
    inscription: '20 USD',
    participation: '720 000 CDF',
    brevet: '50 USD',
  },
];
